const { daysPastSince } = require("../../../utils/timestamp");

export function topExposureDaysCalculate(vulnerabilities) {
  // Calculate the exposure days for each vulnerability
  let daysFound = vulnerabilities?.map((row) => {
    if (row?.published_date?.timestamp_utc_human_readable) {
      return daysPastSince(row?.published_date?.timestamp_utc_human_readable);
    } else {
      return 0;
    }
  });

  // Sort the exposure days in descending order
  daysFound.sort((a, b) => b - a);

  // Calculate the number of items to select (top 20%)
  const top20PercentCount = Math.ceil(daysFound.length * 0.2);

  // Select the top 20% of the sorted exposure days
  const top20PercentDays = daysFound.slice(0, top20PercentCount);
  // Return the number of days that start the top 20%
  return top20PercentDays[top20PercentDays.length - 1];
}

export function getVulnerabilitySource(vulnerabilityID) {
  let sourceURL = "";
  let sourceName = "";

  if (vulnerabilityID.startsWith("CVE-")) {
    sourceURL = `https://nvd.nist.gov/vuln/detail/${vulnerabilityID}`;
    sourceName = "NIST";
  } else if (vulnerabilityID.startsWith("GHSA-")) {
    sourceURL = `https://github.com/advisories/${vulnerabilityID}`;
    sourceName = "GitHub";
  } else if (vulnerabilityID.startsWith("NSWG-")) {
    const nswgID = vulnerabilityID.split("-").pop();
    sourceURL = `https://github.com/nodejs/security-wg/blob/main/vuln/npm/${nswgID}.json`;
    sourceName = "Node.js Security WG";
  }
  return { sourceURL, sourceName };
}
